import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-[var(--radius-sm)] px-2 py-0.5 text-xs font-medium font-sans border transition-colors",
  {
    variants: {
      variant: {
        // Neutral - counts, tags, labels
        default:
          "bg-muted text-foreground border-transparent",

        // Brand - plan badges, highlights
        primary:
          "bg-primary-subtle text-primary border-[hsl(var(--brand-200))]",

        // Success - active, confirmed, complete
        success:
          "bg-[hsl(var(--success-bg))] text-[hsl(var(--success-fg))] border-[hsl(var(--success-border))]",

        // Warning - caution, attention needed
        warning:
          "bg-[hsl(var(--warning-bg))] text-[hsl(var(--warning-fg))] border-[hsl(var(--warning-border))]",

        // Destructive - errors, over-limit, removed
        destructive:
          "bg-[hsl(var(--destructive-bg))] text-[hsl(var(--destructive-fg))] border-[hsl(var(--destructive-border))]",

        // Info - permissions, informational
        info:
          "bg-[hsl(var(--info-bg))] text-[hsl(var(--info-fg))] border-[hsl(var(--info-border))]",

        // Outline - subtle, secondary label
        outline:
          "bg-transparent text-foreground border-border",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

function Badge({ className, variant, ...props }) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants };
